module.exports = __webpack_public_path__ + "static/media/rightArrowUnSelected.073ee04a.svg";